import WebFont from 'webfontloader';

WebFont.load({
  google: {
    families: ['Montserrat:500,600,700,800', 'Raleway:500,600,700,800', 'Material Icons']
  }
});
